var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHamberger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 15,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2275A1",
    fillRule: "evenodd",
    d: "M1.455 0h17.09C19.345 0 20 .628 20 1.398c0 .769-.654 1.397-1.455 1.397H1.455C.655 2.795 0 2.167 0 1.398 0 .628.654 0 1.455 0Zm0 12.205h17.09c.8 0 1.455.628 1.455 1.397 0 .77-.654 1.398-1.455 1.398H1.455C.655 15 0 14.371 0 13.602c0-.769.654-1.397 1.455-1.397Zm0-6.103h17.09c.8 0 1.455.628 1.455 1.397 0 .77-.654 1.398-1.455 1.398H1.455C.655 8.897 0 8.268 0 7.499c0-.767.654-1.397 1.455-1.397Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v15H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamberger);
export default __webpack_public_path__ + "static/media/Hamberger.bedf161a5bb5837306f5b1e4f860fe24.svg";
export { ForwardRef as ReactComponent };